export const sizes = {
   ExtraSmall: 'py-8px px-14px text-sm-medium  rounded-8px',
   Small: 'py-8px px-14px text-md-medium rounded-8px',
   Medium: 'py-10px px-14px text-md-medium rounded-10px',
   sizes: {
      ExtraSmall: 18,
      Small: 20,
      Medium: 20
   }
}

export const placeholderTextSizes = {
   ExtraSmall: ' text-sm-regular',
   Small: 'text-md-regular',
   Medium: ' text-md-regular'
}
